import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  Collapsible,
  ColorPicker,
  Layout,
  InlineStack,
  TextField,
  BlockStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const MenuTab = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, MENU, DEFAULT_MENU_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.menuColor.title")}
        description={cms("section.menuColor.description")}
      >
        <Card
          title={[
            cms("section.menuColor.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.menuColor.subDescription")}</BlockStack>
            <br />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack>
                  <TextField
                    label={cms("section.menuColor.label.hexCode")}
                    value={hex.menuHex}
                    onChange={(value) => handleChange(MENU, value, HEX)}
                    labelAction={
                      hex.menuHex !== DEFAULT_MENU_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(MENU, DEFAULT_MENU_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.menu}
                  />
                  <br />
                  <Text as="span" variant="bodySm">
                    <div
                      style={{
                        borderRadius: ".5rem",
                        width: "max-content",
                        height: "28px",
                        color: hex.menuHex,
                        textAlign: "center",
                        padding: "6px 12px",
                      }}
                    >
                      {cms("section.menuColor.label.sampleHeader")}
                    </div>
                  </Text>
                </BlockStack>
              </Box>
              <ColorPicker onChange={(value) => handleChange(MENU, value, COLOR)} color={color.menuColor} />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(MenuTab);
